import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { FlashCSSStyleImpl } from './flashcss';
import { FlashViewImpl } from './flashview';

export interface FlashComponentProps extends UIComponentProps
{
    packTitle: string;
    id:string;

    showToneOptionsPopup(id:string):void;
    closePopup(): void;
   
}
export interface FlashComponentHandler extends UIComponentHandler
{
    closePopup(): void;
    onSubscibeNow(): void;
}


export class FlashComponent extends UIComponentImpl<FlashComponentProps, UIComponentState, UIDataModel> 
implements FlashComponentHandler
{
    constructor(props: FlashComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FlashViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FlashCSSStyleImpl(applicationContext);
    }

    closePopup():void
    {

        if(this.props.context.getUserContext().getLanguage() === LanguageConst.ENGLISH){

                this.props.context.getUserContext().setEAUCEnglishPackEnabled(true);

                this.props.context.setUserContext(this.getContext().getUserContext());
                // console.log("Pack $$$$$$$$$$$$$$$$$$$$$$2",  this.props.context.getUserContext().getEAUCPackEnabled());

                this.props.closePopup();
        }
        else{
            this.props.context.getUserContext().setEAUCBurmesePackEnabled(true);

            this.props.context.setUserContext(this.getContext().getUserContext());
            // console.log("Pack $$$$$$$$$$$$$$$$$$$$$$2",  this.props.context.getUserContext().getEAUCPackEnabled());

            this.props.closePopup();
        }
    }

    onSubscibeNow()
    {
        if(this.props.context.getUserContext().getLanguage() === LanguageConst.ENGLISH)
        {

                this.props.context.getUserContext().setEAUCEnglishPackEnabled(true);
                this.props.context.setUserContext(this.getContext().getUserContext());
                // console.log("Pack $$$$$$$$$$$$$$$$$$$$$$",JSON.stringify(this.props.context.getUserContext().getEAUCPackEnabled()));

                this.props.showToneOptionsPopup(this.props.context.getResources().getString(Strings.msisdn_validation));
        }
        else{
            this.props.context.getUserContext().setEAUCBurmesePackEnabled(true);
            this.props.context.setUserContext(this.getContext().getUserContext());
            // console.log("Pack $$$$$$$$$$$$$$$$$$$$$$",JSON.stringify(this.props.context.getUserContext().getEAUCPackEnabled()));

            this.props.showToneOptionsPopup(this.props.context.getResources().getString(Strings.msisdn_validation));
        }

    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashpopup/flashcomponent.tsx